import { postProposalApprove } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  ApproveProposalServiceRequest,
  ApproveProposalServiceResponse,
} from './approve-proposal.dto';
import {
  ApproveProposalServiceRequestSchema,
  ApproveProposalServiceResponseSchema,
} from './approve-proposal.dto';

export const approveProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(ApproveProposalServiceRequestSchema),
    async (request: ApproveProposalServiceRequest): Promise<ApproveProposalServiceResponse> => {
      const apiResponse = await postProposalApprove(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 제안 수락에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(ApproveProposalServiceResponseSchema),
  ),
);
